<template>
  <span>{{ toRead }}</span>
</template>

<script>
export default {
  props: {
    msg: { type: Object, required: true },
    read: { type: Object, required: true },
    cmids: { type: Array, resquired: true },
  },
  computed: {
    toRead() {
      var c = 0;
      for (var cmid of this.cmids) if (this.read[cmid] >= this.msg.num) c++;
      if (c == 0) return '';
      var r = $T('talk.read');
      if (this.cmids.length == 1) return r;
      return r + c;
    },
  },
};
</script>
